import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { IconContext } from "react-icons/lib";
import SidebarData from 'components/SidebarData';
import SubMenu from 'components/SubMenu';
import authService from 'services/AuthService';



const Sidebar = () => {
    const [openItem, setOpenItem] = useState(null);
    const { t } = useTranslation();

    const [sidebar, setSidebar] = useState(false);

    // const showSidebar = () => setSidebar(!sidebar);

    // const [isSubmenuOpen, setIsSubmenuOpen] = useState({});

    // const toggleSubmenu = (index) => {
    //   setIsSubmenuOpen((prev) => ({
    //     ...prev,
    //     [index]: !prev[index],
    //   }));
    // };

    const styles = {
        nav: {
            background: "blue",
            height: "80px",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center"
        },
        navIcon: {
            marginLeft: "2rem",
            fontSize: "2rem",
            height: "80px",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center"
        },
        sidebarNav: {
            background: "blue",
            width: "450px",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            position: "fixed",
            top: "0",
            left: sidebar ? "0" : "-100%",
            transition: "350ms",
            zIndex: "10"
        },
        sidebarWrap: {
            width: "100%"
        },
        sidebarHeader: {
            textAlign: "center",
            marginLeft: "200px",
            color: "blue"
        },
    };


    // const [isItemsOpen, setIsItemsOpen] = useState(false);

    // // Toggle the dropdown
    // const toggleItemsDropdown = () => {
    //   setIsItemsOpen(prevState => !prevState);
    // };


    // const toggleSidebar = () => {
    //   setIsOpen(!isOpen);
    // };
    return (<><IconContext.Provider value={{ color: "black" }}>
        <nav
            className={`sidebar-nav ${sidebar ? 'open' : ''}`}
            style={{
                width: "230px",
                borderRight: "2px solid rgb(169, 169, 169)",
                height: "100vh",
            }}
        >
            <div className="sidebar-wrap">
                {SidebarData
                    .filter(item => !item.permission || authService.hasPermission(item.permission))
                    .map((item, index) => (
                        <SubMenu
                            item={item}
                            key={index}
                            codebooktype
                            isOpen={openItem === index}
                            onClick={() => setOpenItem(openItem === index ? null : index)}
                        />
                    ))}
            </div>
        </nav>
    </IconContext.Provider>
    </>

        //   <div className={`sidebar-container ${isOpen ? 'open' : ''}`}>
        //   <div className="sidebar">
        //     <ul className="sidebar-list">
        //       <Link to="/dashboard" className="text-decoration-none">
        //         <li className="sidebar-item">    
        //         <IoMdClipboard />

        //         {t('dashboard')}
        //         </li>
        //       </Link>
        //       {AuthService.isAdmin() && ( <Link to="/users" className="text-decoration-none">
        //         <li className="sidebar-item">
        //         <IoMdPeople />
        //          {t('users')}
        //         </li>
        //       </Link>
        //       )}

        //       <Link to="/requests" className="text-decoration-none">
        //         <li className="sidebar-item">
        //         <IoIosPaper />

        //         {t('requests')}
        //         </li>
        //       </Link>


        //     </ul>
        //   </div>
        // </div>
    );
};

export default Sidebar;